export default {
    '1_month_ago': "кемінде 1 ай",
    '12_months_ago': "кемінде 12 ай",
    '3_months_ago': "кемінде 3 ай",
    '6_months_ago': "кемінде 6 ай",
    above_1_month: "1 айдан артық",
    above_1_year: "1 жылдан артық",
    above_2_months: "2 айдан артық",
    above_3_months: "3 айдан артық",
    above_6_months: "6 айдан артық",
    add_patients: "Пациенттерді қосу",
    add_standard: "Стандарттыларды қосу",
    after_one_day: "Бір күннен кейін",
    after_service: "Қызметтерді алғаннан кейін",
    agreement_to_get_notifications_in_max: "Max'да хабарландырулар алуға келісім",
    all_statuses: "Барлық күйлер",
    amount_of_patients: "Пациенттердің саны",
    april: "Сәуір",
    are_you_sure_you_want_to_delete_mailing: "Шынымен таратылымды жойғыңыз келе ме?",
    august: "Тамыз",
    birth_day: "Туған күні",
    birth_month: "Туған айы",
    cannot_be_delivered: "Жеткізу мүмкін емес",
    channel: "Арна",
    channels: "Арналар",
    complex_status_changed: "Кешеннің статусын емдеу жоспарынан ауыстыру",
    create_mailing: "Таратылымды жасау",
    december: "Желтоқсан",
    do_not_send_at_night_time: "Түнгі уақытта жібермеу (22:00 - 07:00)",
    does_not_contain: "Қамтымайды",
    duplicate: "Көшіру",
    february: "ақпан",
    given_time: "Берілген уақыт",
    has_future_visit: "Алдағы күндерге келу бар",
    has_tags: "Белгілер бар",
    has_treatment_plan_with_status: "Статусы бар емдеу жоспары бар",
    has_visit_with_status: "Статуспен келу бар",
    immediately_after_creating: "Жасағаннан кейін бірден",
    january: "Қаңтар",
    july: "Шілде",
    june: "Маусым",
    laboratory_order_status: "Жұмысқа тапсырыс күйі",
    laboratory_order_status_changed: "Тапсырыстың күйін өзгерту",
    launch_mailing: "Таратылымды іске қосу",
    mailing: "Таратылым",
    mailing_date: "Тарату күні",
    mailing_report: "Таратылым бойынша есеп",
    mailings: "Таратылымдар",
    march: "Наурыз",
    marketing: "Маркетинг",
    marketing_mailing: "Таратылым",
    may: "Мамыр",
    no_push_token: "Токен жоқ",
    not_enough_balance: "Шотта қаражат жеткіліксіз",
    november: "Қараша",
    october: "Қазан",
    of_days: "күндер",
    of_hours: "сағат",
    passed_since_last_visit: "Соңғы келуден кейін өтті",
    payments_were: "Төлем болды",
    plan_status_changed: "Емдеу жоспарының статусы өзгерді",
    push_notification: "Push-хабарлама",
    push_notifications: "Push-хабарламалар",
    ready: "Дайын",
    retry: "Тағы бір рет байқап көру",
    same_day: "Сол күні",
    save_filter: "Сүзгіні сақтау",
    send_again: "Қайта жіберу",
    send_date: "Жіберу күні",
    send_info: "Жіберу туралы ақпарат",
    sent_slash_error: "Жіберілді / Қате",
    september: "Қыркүйек",
    since_last_visit: "Соңғы келуден кейін",
    sms_message: "СМС-хабарлама",
    stop_mailing: "Таратылымды тоқтату",
    tags_for_marketing_mailing: "Ақпаратты автоматты түрде шығаруға арналған тегтер:",
    task_title: "Тапсырма атауы",
    time: "Уақыт",
    token: "Токен",
    tokens: "Токендер",
    too_many_attempts: "Жіберу әрекеттері тым көп",
    total_in_group: "Топта барлығы",
    treatment_plan_created: "Жаңа емдеу жоспары жасалған",
    users_selected: "Пайдаланушылар таңдалды",
    visit_time_changed: "Келу уақыты ауыстырылды",
    wrong_credentials: "Жіберу сервисінің дұрыс емес авторизациялық деректері",
    wrong_phone_number: "Қате телефон нөмірі"
}
